<script>
    import { createEventDispatcher } from "svelte";
    const dispatch = createEventDispatcher();

    export let currentState;

    function handleStepClick(ev) {
      let stepOfClickedElement = parseInt(ev.target.dataset.step);
      if (currentState > stepOfClickedElement) {
        dispatch("stepChange", stepOfClickedElement);
      }
    }

</script>

<div class="row progressContainer">
  <ul class="list-unstyled multi-steps">
    <li data-step="1" on:click={handleStepClick} class:is-active="{currentState == 1}">Daten</li>
    <li data-step="2" on:click={handleStepClick} class:is-active="{currentState == 2}">Bestellung</li>
    <li data-step="3" on:click={handleStepClick} class:is-active="{currentState == 3}">Zahlung</li>
    <li data-step="4" on:click={handleStepClick} class:is-active="{currentState == 4}">Fertig</li>
  </ul>
</div>

<style>
  .progressContainer {
    padding-top: 20px;
  }
  .multi-steps > li.is-active ~ li:before,
  .multi-steps > li.is-active:before {
    content: counter(stepNum);
    font-family: inherit;
    font-weight: 700;
  }

  .multi-steps {
    z-index: 1;
    display: table;
    table-layout: fixed;
    width: 100%;
  }
  .multi-steps > li {
    cursor: pointer;
    counter-increment: stepNum;
    text-align: center;
    display: table-cell;
    position: relative;
    color: #63b4d1;
    transition: all 0.2s ease-in-out;
  }
  .multi-steps > li:before {
    content: "✓";
    display: block;
    margin: 0 auto 4px;
    background-color: #f1f7f9;
    width: 36px;
    height: 36px;
    line-height: 32px;
    text-align: center;
    font-weight: bold;
    border-width: 2px;
    border-style: solid;
    border-color: #63b4d1;
    border-radius: 50%;
    transition: all 0.2s ease-in-out;
  }
  .multi-steps > li:hover:before {
    background-color: #cde5ec;
  }
  .multi-steps > li:after {
    content: "";
    height: 2px;
    width: 100%;
    background-color: #63b4d1;
    position: absolute;
    top: 16px;
    left: 50%;
    z-index: -1;
    transition: all 0.2s ease-in-out;
  }
  .multi-steps > li:last-child:after {
    display: none;
  }
  .multi-steps > li.is-active:before {
    background-color: #63b4d1;
    border-color: #63b4d1;
    color: #fff;
  }
  .multi-steps > li.is-active {
    cursor: default;
    pointer-events: none;
  }
  .multi-steps > li.is-active ~ li {
    cursor: default;
    pointer-events: none;
    color: #c4e3ee;
  }
  .multi-steps > li.is-active ~ li:before {
    border-color: #c4e3ee;
  }
  .multi-steps > li.is-active ~ li:after,
  .multi-steps > li.is-active:after {
    background-color: #c4e3ee;
  }
</style>
